import React, { Component } from "react";
import _ from "lodash";
import { Form, Input, Upload, Icon, notification } from "antd";
import { withRedux } from "../hoc";
import {
  LayoutPage,
  Button,
  Modal,
  BackgroundImage,
  Image,
} from "../components";
import { createCareerApplies } from "../services/page/careerapplies";
import { createMediasApi } from "../services/medias";

const feather1 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-1.png`;
const feather2 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-2.png`;
const feather3 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-3.png`;
const feather4 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-4.png`;
const feather5 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-5.png`;
const feather6 = `${process.env.PUBLIC_URL}/assets/images/section-4/feather4-1.png`;

const FormItem = Form.Item;

const mapStateToProps = ({ language, t, career, positions }) => {
  return {
    language,
    t,
    careerDescription: _.get(career, "data"),
    positions: _.get(positions, "data"),
  };
};

export default Form.create()(
  @withRedux(mapStateToProps)
  class Career extends Component {
    state = {
      showJobId: 1,
      openModal: false,
    };
    handleClickApplyJob = () => {
      this.setState({ openModal: true });
    };
    handleCloseModalApplyJob = () => {
      this.setState({ openModal: false });
    };
    submit = async (values) => {
      const resume = _.get(values, "resume.0.originFileObj");
      const resumeFile = await createMediasApi(resume);
      const video = _.get(values, "video.0.originFileObj");
      const videoFile = await createMediasApi(video);
      const resumeId = _.get(resumeFile, "data.id");
      const videoId = _.get(videoFile, "data.id");
      const newValues = {
        ...values,
        pdf_id: resumeId,
        video_id: videoId,
      };
      const result = await createCareerApplies(newValues);
      const createStatus = _.get(result, "status");
      notification[createStatus === "success" ? "success" : "error"]({
        message: createStatus === "success" ? "success" : "error",
        duration: 3,
      });
      if (createStatus === "success") {
        this.setState({ openModal: false });
        this.props.form.resetFields();
      }
    };
    handleSubmit = (e) => {
      e.preventDefault();
      this.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.submit(values);
        }
      });
    };
    normFile = (e) => {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    };
    render() {
      const { t, positions, careerDescription } = this.props;
      const { showJobId, openModal } = this.state;
      const video = _.get(careerDescription, "video");
      const imageBanner = _.get(careerDescription, "imageBanner");
      const imageBannerMobile = _.get(careerDescription, "imageBannerMobile");
      const { getFieldDecorator } = this.props.form;
      const uploadProps = {
        accept: "image/*",
        beforeUpload: (file) => {
          return false;
        },
      };
      return (
        <div className="recruit-page">
          <LayoutPage
            type="primary"
            bgColor="#1f0737"
            pageName={t("Casting & Recruitment")}
            media={video}
            image={imageBanner}
            imageMobile={imageBannerMobile}
          />
          <div className="container">
            <div className="container-content">
              <div className="container-recruit-highlight">
                <div className="row no-gutters">
                  <div className="col-lg-6">
                    <div className="container-highlight-image">
                      <BackgroundImage
                        image={_.get(careerDescription, "image")}
                        className="img"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 align-self-end">
                    <div className="container-highlight-content">
                      <div className="highlight-title">
                        <h2>{t(_.get(careerDescription, "title"))}</h2>
                      </div>
                      <div className="highlight-content">
                        <p className="benefits-detail">
                          {t(_.get(careerDescription, "description"))}
                        </p>
                      </div>
                      <div className="container-highlight-button">
                        <Button
                          onClick={() => this.setState({ openModal: true })}
                          ghost
                          bordercolor="#ffb400"
                          className="article-highlight-button"
                        >
                          {t("Apply Now")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Image className="feather1" src={feather1} alt="" />
              <Image className="feather2" src={feather2} alt="" />
              <Image className="feather3" src={feather3} alt="" />
              <Image className="feather4" src={feather4} alt="" />
              <Image className="feather5" src={feather5} alt="" />
              <Image className="feather6" src={feather6} alt="" />

              <div className="container-section-job">
                <div className="border-left-right-outside" />
                <div className="border-left-right-inside" />
                <div className="circle" />
                <h2>{t("Positions Available")}</h2>
                <ul>
                  {_.map(positions, (position, key) => {
                    if (_.get(position, "available") === 0) return null;
                    return (
                      <li className="job-position" key={key}>
                        <Button
                          className={`job-name ${
                            showJobId === _.toNumber(key)
                              ? "job-button-active"
                              : ""
                          }`}
                          onClick={() =>
                            this.setState({
                              showJobId: _.toNumber(key),
                            })
                          }
                        >
                          {t(_.get(position, "name"))}
                          {showJobId === _.toNumber(key) ? (
                            <Icon type="up" />
                          ) : (
                            <Icon type="down" />
                          )}
                        </Button>

                        <div
                          className={`container-job-detail ${
                            showJobId === _.toNumber(key)
                              ? "show-job-detail"
                              : ""
                          }`}
                        >
                          <div className="position-avaliable">
                            <h3>{_.get(position, "available")} Positions</h3>
                            <Button
                              ghost
                              bordercolor="#ffb400"
                              onClick={this.handleClickApplyJob}
                            >
                              {t("Apply Now")}
                            </Button>
                          </div>
                          <Modal
                            className="recruit-modal"
                            centered
                            visible={openModal}
                            onCancel={this.handleCloseModalApplyJob}
                            okText={t("Apply Now")}
                          >
                            <div className="circle-modal" />
                            <div className="form-title">
                              <h2>Application Form</h2>
                            </div>
                            <div className="form-description">
                              <p>
                                To apply for a Partnership Contract, please fill
                                in the form below and upload required documents
                                and click ‘Apply Now’
                              </p>
                            </div>
                            <Form onSubmit={this.handleSubmit}>
                              <div className="row">
                                <div className="col">
                                  <FormItem>
                                    {getFieldDecorator("position")(
                                      <Input placeholder="Position applied for" />
                                    )}
                                  </FormItem>
                                  <FormItem>
                                    {getFieldDecorator("firstname")(
                                      <Input placeholder="Firstname" />
                                    )}
                                  </FormItem>
                                  <FormItem>
                                    {getFieldDecorator("age")(
                                      <Input placeholder="Age" />
                                    )}
                                  </FormItem>
                                </div>
                                <div className="col">
                                  <FormItem>
                                    {getFieldDecorator("expected_salary")(
                                      <Input placeholder="Expected Salary" />
                                    )}
                                  </FormItem>
                                  <FormItem>
                                    {getFieldDecorator("lastname")(
                                      <Input placeholder="Lastname" />
                                    )}
                                  </FormItem>
                                  <FormItem>
                                    {getFieldDecorator("gender")(
                                      <Input placeholder="Gender" />
                                    )}
                                  </FormItem>
                                </div>
                              </div>
                              <FormItem>
                                {getFieldDecorator("address")(
                                  <Input placeholder="Address" />
                                )}
                              </FormItem>
                              <div className="row">
                                <div className="col">
                                  <FormItem>
                                    {getFieldDecorator("province")(
                                      <Input placeholder="Province" />
                                    )}
                                  </FormItem>
                                </div>
                                <div className="col">
                                  <FormItem>
                                    {getFieldDecorator("zipcode")(
                                      <Input placeholder="Post Code" />
                                    )}
                                  </FormItem>
                                </div>
                              </div>
                              <FormItem>
                                {getFieldDecorator("pernal_information")(
                                  <Input
                                    placeholder="Pernal Information"
                                    style={{ marginBottom: 15 }}
                                  />
                                )}
                              </FormItem>
                              <FormItem>
                                <div className="upload-file">
                                  <div className="file-content">
                                    <div className="file-name">
                                      <p>Resume</p>
                                    </div>
                                    <div className="file-rule">
                                      <p>
                                        (Only .pdf or .doc format, File size
                                        under 1 mb.)
                                      </p>
                                    </div>
                                  </div>
                                  {getFieldDecorator("resume", {
                                    valuePropName: "fileList",
                                    getValueFromEvent: this.normFile,
                                  })(
                                    <Upload {...uploadProps}>
                                      <Button ghost className="button-upload">
                                        Choose File
                                      </Button>
                                    </Upload>
                                  )}
                                </div>
                              </FormItem>
                              <FormItem>
                                <div className="upload-file">
                                  <div className="file-content">
                                    <div className="file-name">
                                      <p>VDO Present</p>
                                    </div>
                                    <div className="file-rule">
                                      <p>
                                        (Only VDO File format size under 5 mb.
                                        or VDO link from YouTube channel)
                                      </p>
                                    </div>
                                  </div>
                                  {getFieldDecorator("video", {
                                    valuePropName: "fileList",
                                    getValueFromEvent: this.normFile,
                                  })(
                                    <Upload {...uploadProps}>
                                      <Button ghost className="button-upload">
                                        Choose File
                                      </Button>
                                    </Upload>
                                  )}
                                </div>
                              </FormItem>
                              <FormItem>
                                <Button
                                  ghost
                                  bordercolor="#ffb400"
                                  htmlType="submit"
                                >
                                  {t("Apply Now")}
                                </Button>
                              </FormItem>
                            </Form>
                          </Modal>
                          <div className="row">
                            <div className="col-lg-8 col-md-12">
                              <div className="job-detail candidate">
                                <p>Candidate</p>
                                <div
                                  className="candidate-detail"
                                  dangerouslySetInnerHTML={{
                                    __html: t(_.get(position, "candidate")),
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                              <div className="job-detail">
                                <p>Benefits</p>
                                <div
                                  className="benefits-detail"
                                  dangerouslySetInnerHTML={{
                                    __html: t(_.get(position, "benefits")),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/pages/Career.js